// src/features/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { getCurrentApiUrl, getCurrentBaseUrl } from 'config/server.config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { mainService } from '../services/api/main.service';
import { walletService } from '../services/api/wallet.service';
import { cardService } from '../services/api/card.service';
import { CryptoPrices } from '@/types/application.types';
import { transferService } from '../services/api/transfer.service';
import { logoutAuth } from '../store/authReducer';
interface FiatPrices {
  USD: number;
  EUR: number;
  GBP: number;
  AED: number;
  MEX: number;
  PAN: number;
}
interface MainData {
  virtual: boolean;
  cryptoPrices: CryptoPrices;
  fiatPrices: FiatPrices;
}
interface ResCardBalance {
  card: any, fiatPrices: FiatPrices
}
interface ImportCryptoWalletData {
  info: any,
  currency: string,
  endpoint: string
}
interface TransferInternalData {
  amount: number,
  originRailAccountId:string,
  currency: string,
  destinationEmail:string
}
export const getMainWallets = createAsyncThunk('data/fetchMainWallets', async (data: MainData) => {
  let totalFiatValue = 0;
  let totalCustodianValue = 0;
  const response = await mainService.getMainWallets(data.virtual);
  if (response.success === true) {
    response?.accounts.fiat?.forEach(wallet => {
      let usdValue = 0;
      if (wallet.availableBalance && wallet.availableBalance !== "0.00") {
        const balance = parseFloat(wallet.availableBalance);
        usdValue = data.fiatPrices[wallet.currency] ? balance * data.fiatPrices[wallet.currency] : balance;
        totalFiatValue += usdValue;
      }
    });
    response?.accounts.crypto?.forEach(wallet => {
      let usdValue = 0;
      if (wallet.balance) {
        const balance = parseFloat(wallet.balance);
        usdValue = data.cryptoPrices[wallet.currency] ? balance * data.cryptoPrices[wallet.currency] : balance;
        totalCustodianValue += usdValue;
      }
    });
  }
  return { response, totalFiatValue, totalCustodianValue };
});
export const getCryptoWallets = createAsyncThunk('data/fetchCryptoWallets', async (cryptoPrices: CryptoPrices) => {
  let totalCryptoValue = 0;
  const response = await walletService.getCryptoWallets();
  // if (response.wallets.length > 0) {
  //   response.wallets?.forEach(wallet => {
  //     let usdValue = 0;
  //     if (wallet.balance) {
  //       const balance = parseFloat(wallet.balance);
  //       usdValue = cryptoPrices[wallet.currency] ? balance * cryptoPrices[wallet.currency] : balance;
  //       console.log(`${balance} * ${cryptoPrices[wallet.currency]} = ${usdValue}`);
  //       totalCryptoValue += usdValue;
  //     }
  //   });
  // }
  return { response, totalCryptoValue };
});
export const getMasterCardData = createAsyncThunk('data/fetchMasterCardData', async () => {
  const response = await cardService.getMasterCardData();
  return response;
});
export const getMasterCardBalance = createAsyncThunk('data/fetchMasterCardBalance', async (data: ResCardBalance) => {
  const response = await cardService.getMasterCardBalance(data.card);
  const cardBalance = response.data.balance * data.fiatPrices[response.data.currency];
  return { balance: cardBalance, currency: response.data.currency };
});

export const getZenusAccount = createAsyncThunk('data/fetchZenusAccount', async () => {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const baseUrl = getCurrentBaseUrl();

    // OPTIMIZATION: Una sola llamada a /balance que ya incluye la info de la cuenta
    // Esto elimina el duplicate call a /my-account, reduciendo de 2 a 1 API call
    const balanceResponse = await fetch(`${baseUrl}/api/providers/zenus/balance`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (balanceResponse.ok) {
      const balanceData = await balanceResponse.json();

      if (balanceData.success && balanceData.data) {
        const balance = balanceData.data.available || 0;

        // Trigger background sync (fire and forget)
        fetch(`${baseUrl}/api/providers/zenus/transactions/sync`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }).catch(() => {
          // Fail silently
        });

        return {
          account: balanceData.data.account || null,
          balance: balance
        };
      }
    }

    return null;
  } catch (error) {
    console.error('Error fetching Zenus account:', error);
    return null;
  }
});
export const internalTransfer = createAsyncThunk('data/transferInternal', async (data: TransferInternalData) => {
  const response = await transferService.internalTransfer(data);  
  return {response, data};
});
export const createMainAccount = createAsyncThunk('data/createMainAccount', async () => {
  const response = await mainService.createMainAccount();
  return response;
});
export const createMasterCardAccount = createAsyncThunk('data/createMasterCard', async () => {
  // const response = await mainService.createMasterCard();
  // return response;
});
export const createCryptoWallet = createAsyncThunk('data/createCryptoWallet', async (currency: string) => {
  const response = await walletService.createWallet(currency);

  // let cloneCurrency = "";
  // if (response.wallet.address !== "" || response.wallet.address !== null) {
  //   if (currency === "ETH") {
  //     cloneCurrency = "USDT_ERC20";
  //   } else if (currency === "USDT_ERC20") {
  //     cloneCurrency = "ETH";
  //   } else if (currency === "TRX") {
  //     cloneCurrency = "USDT_TRON";
  //   } else if (currency === "USDT_TRON") {
  //     cloneCurrency = "TRX";
  //   } else if (currency === "BNB") {
  //     cloneCurrency = "USDT_BEP20";
  //   } else if (currency === "USDT_BEP20") {
  //     cloneCurrency = "BNB";
  //   }
  //   const updateResponse = [
  //     {
  //       ...response.wallet,
  //       currency: currency,
  //       balance: '0',
  //     },
  //     ...(cloneCurrency
  //       ? [
  //         {
  //           ...response.wallet,
  //           currency: cloneCurrency,
  //           balance: '0',
  //         },
  //       ]
  //       : []),
  //   ];
    // const updateResponse = [
    //   {
    //     address:"test",
    //     currency:currency,
    //     balance: '0',
    //   },
    //   ...(cloneCurrency
    //     ? [
    //         {
    //          address:"test",
    //           currency: cloneCurrency,
    //           balance: '0',
    //         },
    //       ]
    //     : []),
    // ];
    return response;
  // }
});
export const importCryptoWallet = createAsyncThunk('data/importCryptoWallet', async (data: ImportCryptoWalletData) => {
  const res = await walletService.importWallet(data, data.endpoint);
  return res;
});
const initialState = {
    data: {
      mainWallets: {
        fiatWallets: {
          balance: 0,
          data: []
        },
        custodianWallets: {
          balance: 0,
          data: []
        },
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
      },
      cryptoWallets: {
        balance: 0,
        data: {
          bitcoin:[],
          ethereum:[],
          bnb:[],
          tron:[],
          solana:[]
        },
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
        importStatus: 'idle',
        importError: null,
        createStatus: 'idle',
        createError: null
      },
      masterCard: {
        balance: 0,
        currency: '',
        data: [],
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
      },
      zenusAccount: {
        account: null,
        balance: 0,
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
      },
    },
    status: 'succeeded', // 'idle' | 'loading' | 'succeeded' | 'failed'

  }
const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    updateAssetsStatus(state) {
      state.status = 'succeeded';
    },
    transferInternalData(state, info){
      const walletFiat = state.data.mainWallets.fiatWallets.data.find(w => w.currency === info.payload.currency);
      if (walletFiat) {
        walletFiat.balance = walletFiat.balance - info.payload.balance;
        return;
      }else{
        const walletCustodian = state.data.mainWallets.fiatWallets.data.find(w => w.currency === info.payload.currency);
        walletCustodian.balance = walletCustodian.balance - info.payload.balance;
        return
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMainWallets.pending, (state) => {
        state.data.mainWallets.status = 'loading';
      })
      .addCase(getMainWallets.fulfilled, (state, action) => {
        state.data.mainWallets.status = 'succeeded';
        state.data.mainWallets.fiatWallets.data = action.payload.response.accounts.fiat;
        state.data.mainWallets.fiatWallets.balance = action.payload?.totalFiatValue ? action.payload?.totalFiatValue : 0;
        state.data.mainWallets.custodianWallets.data = action.payload.response.accounts.crypto; // Save API data to store
        state.data.mainWallets.custodianWallets.balance = action.payload?.totalCustodianValue ? action.payload?.totalCustodianValue : 0;
      })
      .addCase(getMainWallets.rejected, (state, action) => {
        state.data.mainWallets.status = 'failed';
        state.data.mainWallets.error = action.error.message;
      })
      .addCase(getCryptoWallets.pending, (state) => {
        state.data.cryptoWallets.status = 'loading';
      })
      .addCase(getCryptoWallets.fulfilled, (state, action) => {
        state.data.cryptoWallets.status = 'succeeded';
        state.data.cryptoWallets.data = action.payload.response;
        state.data.cryptoWallets.balance = action.payload?.totalCryptoValue ? action.payload?.totalCryptoValue : 0;
      })
      .addCase(getCryptoWallets.rejected, (state, action) => {
        state.data.cryptoWallets.status = 'failed';
        state.data.cryptoWallets.error = action.error.message;
      })
      .addCase(getMasterCardData.pending, (state) => {
        state.data.masterCard.status = 'loading';
      })
      .addCase(getMasterCardData.fulfilled, (state, action) => {
        state.data.masterCard.status = 'succeeded';
        // Manejo seguro de la respuesta
        let cardsData = [];
        
        if (action.payload?.data?.data?.data) {
          cardsData = action.payload.data.data.data;
        } else if (action.payload?.data?.data) {
          cardsData = Array.isArray(action.payload.data.data) ? action.payload.data.data : [];
        } else if (action.payload?.data) {
          cardsData = Array.isArray(action.payload.data) ? action.payload.data : [];
        }
        
        const newCards = Array.isArray(cardsData)
          ? cardsData.filter(
            (newCard) => !state.data.masterCard.data.some((existing) => existing.id === newCard.id)
          )
          : [];
        state.data.masterCard.data.push(...newCards);
      })
      .addCase(getMasterCardData.rejected, (state, action) => {
        state.data.masterCard.status = 'failed';
        state.data.masterCard.error = action.error.message;
      })
      .addCase(getMasterCardBalance.pending, (state) => {
        state.data.masterCard.status = 'loading';
      })
      .addCase(getMasterCardBalance.fulfilled, (state, action) => {
        state.data.masterCard.status = 'succeeded';
        state.status = "succeeded"
        state.data.masterCard.balance = action?.payload?.balance || 0;
        state.data.masterCard.currency = action?.payload?.currency || 'EUR';
      })
      .addCase(getMasterCardBalance.rejected, (state, action) => {
        state.data.masterCard.status = 'failed';
        state.data.masterCard.error = action.error.message;
        state.status = "succeeded"
      })
      .addCase(createCryptoWallet.pending, (state) => {
        state.data.cryptoWallets.createStatus = 'loading';
      })
      .addCase(createCryptoWallet.fulfilled, (state, action) => {
        state.data.cryptoWallets.createStatus = 'succeeded';
        // state.data.cryptoWallets.data.push(action.payload[0])
        // if (action.payload.length > 1) {
        //   state.data.cryptoWallets.data.push(action.payload[1])
        // }
      })
      .addCase(createCryptoWallet.rejected, (state, action) => {
        state.data.cryptoWallets.createStatus = 'failed';
        state.data.cryptoWallets.createError = action.error.message;
      })
      // .addCase(importCryptoWallet.pending, (state) => {
      //   state.data.cryptoWallets.importStatus = 'loading';
      // })
      // .addCase(importCryptoWallet.fulfilled, (state, action) => {
      //   if (action.payload.wallets.length > 0) {
      //     state.data.cryptoWallets.data.push(action.payload.wallets[0])
      //     if (action.payload.wallets.length > 1) {
      //       state.data.cryptoWallets.data.push(action.payload.wallets[1])
      //     }

      //     state.data.cryptoWallets.importError = null
      //     state.data.cryptoWallets.importStatus = 'succeeded';
      //   } else {
      //     state.data.cryptoWallets.importStatus = 'failed';
      //     state.data.cryptoWallets.importError = action.payload.error;
      //   }
      // })
      // .addCase(importCryptoWallet.rejected, (state, action) => {
      //   state.data.cryptoWallets.importStatus = 'failed';
      //   state.data.cryptoWallets.importError = action.error.message;
      // })
      // .addCase(internalTransfer.fulfilled, (state, action) => {
      //   const updateWallet = state.data.cryptoWallets.data.filter((w)=>{
      //     return w.currency === action.
      //   })
      //   if (action.payload.length > 1) {
      //     state.data.cryptoWallets.data.push(action.payload[1])
      //   }
      // })
      .addCase(getZenusAccount.pending, (state) => {
        state.data.zenusAccount.status = 'loading';
      })
      .addCase(getZenusAccount.fulfilled, (state, action) => {
        state.data.zenusAccount.status = 'succeeded';
        if (action.payload) {
          state.data.zenusAccount.account = action.payload.account;
          state.data.zenusAccount.balance = action.payload.balance;
        } else {
          state.data.zenusAccount.account = null;
          state.data.zenusAccount.balance = 0;
        }
      })
      .addCase(getZenusAccount.rejected, (state, action) => {
        state.data.zenusAccount.status = 'failed';
        state.data.zenusAccount.error = action.error.message;
      })
      .addCase(logoutAuth, () => initialState);


  },
});

export const { updateAssetsStatus, transferInternalData} = assetsSlice.actions;
export default assetsSlice.reducer;